import { render } from "./system-settings.vue?vue&type=template&id=f5760ffc"
import script from "./system-settings.vue?vue&type=script&lang=js"
export * from "./system-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__